import { createFileRoute } from '@tanstack/react-router';

import { CampaignPlanningPage } from '@/features/campaign-planning';

export const Route = createFileRoute('/workspace/$workspaceId/campaign-planning/')({
  component: CampaignPlanningPage,
});
